import { Quote } from 'src/shared/quote.dto'

import { StockopediaRestClient } from '../http-client/stockopedia.client'

interface QuoteResponse {
  data: Quote
}

interface SearchItem {
  id: number
  name: string
  image: string
  ticker: string
  type: string
  region: string
  exchange: string
  permalink: string
}

export interface SearchResponse {
  data: SearchItem[]
}

export class StockReportsClient {
  constructor(private readonly httpClient: StockopediaRestClient) {}

  async getQuote(id: string): Promise<QuoteResponse> {
    const { data } = await this.httpClient.get<QuoteResponse>(
      `/v1/quotes/${id}`,
    )

    return data
  }

  async searchSecurities(term: string): Promise<SearchResponse> {
    const { data } = await this.httpClient.get<SearchResponse>(
      `/v1/search?term=${encodeURIComponent(term)}`,
    )

    return data
  }
}
